import React from 'react';

const PreventiveCorrectiveBar = ({ data }) => {
  const colorMap: Record<string, string> = {
    Preventative: '#00008b',
    Corrective: '#ff2424ff',
    Improvement: '#7a99cb',
  };

  const total = data.reduce((sum, d) => sum + d.totalHours, 0) || 1;

  return (
    <div
      style={{height: '100%',display: 'flex',flexDirection: 'column',justifyContent: 'flex-end',}}>
      <div
        style={{flexGrow: 1, display: 'flex',width: '100%',borderRadius: 6,overflow: 'hidden',}}>
        {data.map((item) => {
          const percent = (item.totalHours / total) * 100;
          return (
            <div
              key={item.typeName}
              style={{ width: `${percent}%`, background: colorMap[item.typeName], display: 'flex', alignItems: 'center', justifyContent: 'center',color: '#fff',fontSize: "1vw",}}>
              {percent > 8 ? `${percent.toFixed(0)}%` : ''}
            </div>
          );
        })}
      </div>

      <div
        style={{display: 'flex',gap: 16,marginTop: 8,flexWrap: 'wrap',alignItems: 'center',}}>
        {data.map((item) => (
          <div
            key={item.typeName}
            style={{display: 'flex',alignItems: 'center',gap: 6,}}>
            <div style={{ width: 8, height: 8, borderRadius: 0, background: colorMap[item.typeName], }} />
            <span style={{ fontSize: 12 }}>{item.typeName}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreventiveCorrectiveBar;
